module.exports = __webpack_public_path__ + "static/media/smartphone.9bca053a.png";